import React, { useState } from 'react';
import SiteSearch from 'wix-ui-icons-common/SiteSearch';
import s from './solution-overview.scss';
import { biLogger } from '../../../../bi';
import { DescriptionBenefits } from './description-benefits';
import { DescriptionPreviewWrapper, DemoLinkPreviewWrapper, } from '../../preview-elements/';
import { Text, Heading, TextButton, Card, Divider, Box } from 'wix-style-react';
import { VisibilityDetector } from '../../../visibility-detector/visibility-detector';
var SolutionDescription = function (_a) {
    var solutionDemo = _a.solutionDemo, t = _a.t, description = _a.description, name = _a.name, benefits = _a.benefits, appId = _a.appId, biData = _a.biData;
    var _b = useState(false), isBodyExpanded = _b[0], updateIsBodyExpanded = _b[1];
    var _c = useState(false), showReadMore = _c[0], updateShowReadMore = _c[1];
    var DemoLinkWrp = function () {
        return solutionDemo ? (React.createElement("div", null,
            React.createElement(Divider, null),
            React.createElement(TextButton, { className: s.solutionDemoLink, dataHook: "developer-name-solution-description", onClick: function () { return onDemoLinkClick(biData); }, as: "a", size: "medium", target: "_blank", href: solutionDemo && solutionDemo, prefixIcon: React.createElement(SiteSearch, null) }, solutionDemo ? t('solution.page.demo.link') : null),
            ' ')) : null;
    };
    var expandToggle = function () {
        updateIsBodyExpanded(!isBodyExpanded);
    };
    var descriptionStyle = showReadMore && !isBodyExpanded ? s.longDescription : '';
    var DescriptionPreview = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(DescriptionPreviewWrapper, { description: description },
                React.createElement(Box, { maxHeight: !isBodyExpanded ? '250px' : '100%', marginBottom: !showReadMore ? '24px' : '0px', overflow: !isBodyExpanded ? 'hidden' : 'none' },
                    React.createElement("div", { className: descriptionStyle },
                        React.createElement(Text, { weight: "thin", dataHook: "solution-description", className: 'text-description' }, description),
                        !isBodyExpanded && (React.createElement(VisibilityDetector, { onUnVisible: function () { return updateShowReadMore(true); }, onVisible: function () {
                                updateShowReadMore(false);
                            } },
                            React.createElement("div", null)))))),
            showReadMore && (React.createElement(TextButton, { className: s.readMoreBtn, size: "medium", onClick: expandToggle }, isBodyExpanded
                ? t('solution.page.review.readLess')
                : t('solution.page.review.readMore')))));
    };
    return (React.createElement(Card, { className: s.descriptionContent },
        React.createElement(Heading, { appearance: "H2", className: s.descriptionHeader, dataHook: "solution-name" }, t('solution.page.solutionOverView', {
            name: name,
        })),
        React.createElement(Box, { direction: "vertical", align: "left", className: s.descriptionBenefitsContainer },
            React.createElement(DescriptionBenefits, { benefits: benefits, appId: appId })),
        React.createElement(DescriptionPreview, null),
        React.createElement(DemoLinkPreviewWrapper, { src: solutionDemo },
            React.createElement(DemoLinkWrp, null))));
};
var onDemoLinkClick = function (biData) {
    // @ts-ignore
    biLogger.appMarketDemoLinkClicked(biData);
};
export default SolutionDescription;
//# sourceMappingURL=solution-description.js.map